import React from 'react';
import SchedulerShell from '../components/calendar/SchedulerShell';

// Calendar entrypoint now renders the SchedulerShell with Day/Week/Month views
// and a right-hand Unscheduled/Booked staging column.
const Calendar = () => {
  return <SchedulerShell />;
};

export default Calendar;
